import React, { useState, useRef, useEffect, useCallback } from 'react';
import { Card, Row, Col, Typography, List, Space, Empty } from 'antd';
import { Doughnut } from 'react-chartjs-2';
import { useNavigate, Link } from 'react-router-dom';
import arrowIcon from 'assets/arrow.png';
import { getLatestRoles } from '../../../actions';
import {useSelector, useDispatch} from 'react-redux'
const { Title, Text } = Typography;


const latestRolesData = [
  {
    roleName: "Mechanical Engineer (Internship) - Freshers",
    
  },
  {
    roleName: "Technical Safety (Job) - (Fresher)",
    
  },
  {
    roleName: "Electrical & Instrumentation (Internship) - Freshers",
    
  },
];

const OverallAndLatestRoles = ({ selectedFilter, setSelectedFilter }) => {
  const [selected, setSelected] = useState(null);
  const [showAll, setShowAll] = useState(false);
  const [latestRoles, setLatestRoles] = useState(latestRolesData);
  const chartRef = useRef(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const tpoMetrics = useSelector(state => state)
  const JobMetrics = useSelector(state => state?.corporateDashboardPage2?.latestRolesData?.jobMetrics)
  console.log("tpoMetrics",tpoMetrics)

  // Check if there's any data for the doughnut chart
  const hasDonutData = JobMetrics && (
    (JobMetrics?.jobs || 0) > 0 ||
    (JobMetrics?.internship || 0) > 0 ||
    (JobMetrics?.apprenticeship || 0) > 0 ||
    (JobMetrics?.projects || 0) > 0 ||
    (JobMetrics?.internship_ppo || 0) > 0
  );

  const doughnutData = {
    labels: ["Roles", "Internship", "Apprenticeship", "Projects","Internship+PPO"],
    datasets: [{
      data: [JobMetrics?.jobs || 0, JobMetrics?.internship || 0, JobMetrics?.apprenticeship || 0, JobMetrics?.projects || 0, JobMetrics?.internship_ppo || 0],
      backgroundColor: ["#001F54", "#0077B6", "#00B4D8", "#48CAE4", "#00edfe7f"],
      borderColor: ["#FFFFFF"],
      borderWidth: 1,
      hoverBackgroundColor: ["#001A46", "#0066A3", "#00A0C8", "#3AB8D4", "#00edfe7f"]
    }],
  };

  // Function to map item names to filter values
  const mapItemToFilter = (itemName) => {
    switch (itemName) {
      case "Roles": return "JOBS";
      case "Internship": return "INTERNSHIP";
      case "Apprenticeship": return "APPRENTICESHIP";
      case "Projects": return "PROJECTS";
      case "Internship+PPO": return "INTERNSHIP_PPO";
      default: return "JOBS";
    }
  };

  const convertJobType = (jobType)=>{
    let convertedJobType = jobType;
    if(jobType === "PLACEMENT"){
      convertedJobType = "Roles";
    }
    else if(jobType ==="GIGS"){
      convertedJobType = "PROJECTS";
    }
    return convertedJobType?.toLowerCase();   
  }

  // Function to extract job type from role text and update filter
  const handleRoleClick = (roleText) => {
    let jobType = "JOBS"; // default
    
    if (roleText.toLowerCase().includes("internship")) {
      jobType = "INTERNSHIP";
    } else if (roleText.toLowerCase().includes("apprenticeship")) {
      jobType = "APPRENTICESHIP";
    } else if (roleText.toLowerCase().includes("project")) {
      jobType = "PROJECTS";
    }
    
    if (setSelectedFilter) {
      setSelectedFilter(jobType);
    }
  };

  const doughnutOptions = {
    responsive: true,
    maintainAspectRatio: false,
    animation: { animateRotate: true, animateScale: true }, 
    
    cutout: "60%",
    plugins: {
      legend: { display: false },
      tooltip: { callbacks: { label: (c) => `${c.label}: ${c.parsed}` } },
      datalabels: {
        display: false,
      },
    },
  };

  const handleLegendClick = useCallback(
    (item) => {
      const index = doughnutData.labels.indexOf(item.name);
      const selectedItem = {
        ...item,
        color: doughnutData.datasets[0].backgroundColor[index],
      };
      setSelected(selectedItem);
      // Navigate to placements when clicking on Roles
      if (item.name === "Roles") {
        navigate('/rolePage?jobType=PLACEMENT');
      } else if (item.name === "Internship") {
        navigate('/rolePage?jobType=INTERNSHIP');
      } else if (item.name === "Internship+PPO") {
        navigate('/rolePage?jobType=INTERNSHIP_PPO');
      } else if (item.name === "Apprenticeship") {
        navigate('/rolePage?jobType=APPRENTICESHIP');
      } else if (item.name === "Projects") {
        navigate('/rolePage?jobType=PROJECT');
      }
    },
    [navigate] // Add navigate to dependencies
  );

  useEffect(() => {
    dispatch(getLatestRoles())
    const handleClickOutside = (event) => {
      if (chartRef.current && !chartRef.current.contains(event.target)) {
        setSelected(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [ dispatch ]);

  useEffect(() => {
    setLatestRoles(tpoMetrics?.corporateDashboardPage2?.latestRolesData?.roleList || latestRolesData)
    console.log("tpoMetrics?.corporateDashboardPage2?.latestRolesData",tpoMetrics?.corporateDashboardPage2?.latestRolesData)
  }, [tpoMetrics?.corporateDashboardPage2?.latestRolesData])

  return (
    <Card bordered={true} className="cd-card" style={{ padding: "24px" }}>
      <Row gutter={[24, 16]} align="top">
        <Col xs={24} lg={17}>
          <Title level={3} style={{ fontFamily: 'Plus Jakarta Sans', fontWeight: 450, fontSize: '20px', lineHeight: '24px', color:'rgba(0, 0, 0, 1)'}}>Overall</Title>
          <Row gutter={[16, 16]} align="middle" justify="center">
            {hasDonutData ? (
              <>
                <Col xs={24} sm={8} ref={chartRef} style={{ marginRight: '60px' }}>
                  <div style={{ position: "relative", height: "240px", width: "240px", margin: "0 auto" }}>
                    <Doughnut data={doughnutData} options={doughnutOptions} />
                  </div>
                </Col>
                <Col xs={24} sm={14}>
                  {selected ? (
                    <div style={{ padding: "16px", background: "#e6f7ff", borderRadius: "8px" }}>
                      <Space align="center" style={{ marginBottom: "8px" }}>
                        <div style={{ width: "16px", height: "16px", borderRadius: "50%", backgroundColor: selected.color }} />
                        <Title level={5} style={{ fontFamily: 'Plus Jakarta Sans', fontWeight: 400, fontSize: '20px', lineHeight: '24px', letterSpacing: '0%', margin: 0 }}>{selected.name}</Title>
                      </Space>
                      <Title level={2} style={{ fontFamily: 'Plus Jakarta Sans', fontWeight: 800, fontSize: '20px', lineHeight: '24px', letterSpacing: '0%', margin: 0 }}>{selected.value}</Title>
                    </div>
                  ) : (
                    <Row gutter={[16, 16]}>
                      {doughnutData.labels.map((label, index) => {
                        const value = doughnutData.datasets[0].data[index] || 0;
                        // Only show legend if value > 0
                        if (value > 0) {
                          return (
                            <Col span={12} key={index}>
                              <div onClick={() => handleLegendClick({ name: label, value })} style={{ cursor: "pointer", display: 'flex', alignItems: 'flex-start' }}>
                                <div style={{ width: "10px", height: "10px", backgroundColor: doughnutData.datasets[0].backgroundColor[index], borderRadius: "50%", marginRight: '8px', marginTop: '5px' }} />
                                <div style={{ width: '130px' }}>
                                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                                    <span style={{ fontFamily: 'Plus Jakarta Sans', fontWeight: 400, fontSize: '20px', lineHeight: '24px', letterSpacing: '0%' }}>{label}</span>
                                    {(label === "Internship" || label === "Apprenticeship" || label === "Projects" || label === "Roles" || label === "Internship+PPO") && (
                                      <img 
                                        src={arrowIcon} 
                                        alt="arrow" 
                                        style={{ 
                                          marginLeft: '10px'
                                        }}
                                      />
                                    )}
                                  </div>
                                  <Title level={5} style={{ fontFamily: 'Plus Jakarta Sans', fontWeight: 800, fontSize: '20px', lineHeight: '24px', letterSpacing: '0%', margin: 0 }}>{value}</Title>
                                </div>
                              </div>
                            </Col>
                          );
                        }
                        return null;
                      })}
                    </Row>
                  )}
                </Col>
              </>
            ) : (
              <Col span={24} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '200px' }}>
                <Empty />
              </Col>
            )}
          </Row>
        </Col>
        
        {/* Added style for the vertical line */}
        <Col xs={24} lg={6} style={{ borderLeft: '2px solid #CFCFCF', paddingLeft: '48px' }}>
          <Title level={4} style={{ fontFamily: 'Plus Jakarta Sans', fontWeight: 400, fontSize: '20px', lineHeight: '24px', letterSpacing: '0%' }}>Latest Roles</Title>
          <List
            style={{ marginTop: '20px' }}
            dataSource={showAll ? latestRoles : latestRoles.slice(0, 5)}
            renderItem={(item) => (
              <List.Item style={{ border: "none", padding: "6px 0" }}>
                <Link 
                  to={`/jobRoles/jobPreview/${item.roleId}?selectedCategory=${item.jobtype}&q=APPLIED`}
                  style={{ color: 'rgba(50, 73, 215, 1)' }}
                >
                  {item.roleName}-{convertJobType(item.jobtype)}
                </Link>
              </List.Item>
            )}
          />
          {latestRoles && latestRoles.length > 0 && (
            <div>
              <Link 
                to="#" 
                style={{ color: 'rgba(50, 73, 215, 1)', fontSize: '14px', textDecoration: 'underline', fontWeight: 'bold' }}
                onClick={(e) => {
                  e.preventDefault();
                  navigate('/rolePage');
                }}
              >
                View All
              </Link>
            </div>
          )}
        </Col>
      </Row>
    </Card>
  );
};

export default OverallAndLatestRoles;